import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'

import { ArrowBottomIcon, CloseIcon } from '~/components/Abstracts/Icons'
import { ImageGalleryProps } from '~/components/UI/ImageGallery'

import { GENERAL } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ImageGalleryControls {
  imagesProps?: ImageGalleryProps['imagesProps']
  onPreviousClick?: ImageGalleryProps['onPreviousClick']
  onNextClick?: ImageGalleryProps['onNextClick']
  onExitFullscreen?: ImageGalleryProps['onExitFullscreen']
}

export default function ImageGalleryControls({
  className,
  imagesProps,
  onPreviousClick,
  onNextClick,
  onExitFullscreen,
}: ImageGalleryProps) {
  const t = useTranslate()

  return (
    <div className={cx(css.ImageGalleryControls, className)}>
      <div className={css.left}>
        {imagesProps?.length > 0 && (
          <>
            <button
              aria-label={t(GENERAL.FULLSCREEN_PREVIOUS)}
              className={css.controlItem}
              onClick={onPreviousClick}>
              <ArrowBottomIcon className={css.icon} />
            </button>
            <button
              aria-label={t(GENERAL.FULLSCREEN_NEXT)}
              className={css.controlItem}
              onClick={onNextClick}>
              <ArrowBottomIcon className={cx(css.icon, css.iconNext)} />
            </button>
          </>
        )}
      </div>
      <div className={css.right}>
        <button
          aria-label={t(GENERAL.FULLSCREEN_CLOSE)}
          className={css.controlItem}
          onClick={onExitFullscreen}>
          <CloseIcon className={cx(css.icon, css.close)} />
        </button>
      </div>
    </div>
  )
}
